<template>
	<section class="view-ui-icon-pad">
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 17.1429C10.1064 17.1429 8.57142 18.6779 8.57142 20.5714C8.57142 22.465 10.1064 24 12 24C13.8935 24 15.4286 22.465 15.4286 20.5714C15.4286 18.6779 13.8935 17.1429 12 17.1429Z"
				fill="currentColor"
			/>
			<path
				d="M12 -2.50953e-05C10.1064 -2.52608e-05 8.57142 1.535 8.57142 3.42855C8.57142 5.32209 10.1064 6.85712 12 6.85712C13.8935 6.85712 15.4286 5.32209 15.4286 3.42855C15.4286 1.535 13.8935 -2.49297e-05 12 -2.50953e-05Z"
				fill="currentColor"
			/>
			<path
				d="M20.5714 -2.50953e-05C18.6779 -2.52608e-05 17.1429 1.535 17.1429 3.42855C17.1429 5.32209 18.6779 6.85712 20.5714 6.85712C22.465 6.85712 24 5.32209 24 3.42855C24 1.535 22.465 -2.49297e-05 20.5714 -2.50953e-05Z"
				fill="currentColor"
			/>
			<path
				d="M3.42858 -2.50953e-05C1.53503 -2.52608e-05 6.18732e-06 1.535 6.02178e-06 3.42855C5.85624e-06 5.32209 1.53503 6.85712 3.42858 6.85712C5.32212 6.85712 6.85715 5.32209 6.85715 3.42855C6.85715 1.535 5.32212 -2.49297e-05 3.42858 -2.50953e-05Z"
				fill="currentColor"
			/>
			<path
				d="M16.2857 8.57145C14.3922 8.57145 12.8572 10.1065 12.8572 12C12.8572 13.8936 14.3922 15.4286 16.2857 15.4286C18.1793 15.4286 19.7143 13.8936 19.7143 12C19.7143 10.1065 18.1793 8.57145 16.2857 8.57145Z"
				fill="currentColor"
			/>
			<path
				d="M7.71428 8.57145C5.82074 8.57145 4.28571 10.1065 4.28571 12C4.28571 13.8936 5.82073 15.4286 7.71428 15.4286C9.60783 15.4286 11.1429 13.8936 11.1429 12C11.1429 10.1065 9.60783 8.57145 7.71428 8.57145Z"
				fill="currentColor"
			/>
		</svg>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Icon
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiIconPad extends ViewBase {
		// Not implemented
	}
</script>
